// src/Pages/About.jsx
import React, { useState, useEffect } from 'react';
import '../App.css';
import MediumPosts from '../Components/MediumPosts';
import { useTranslation } from 'react-i18next';
import '../Styles/Home.css'; // 引入動畫樣式

export default function About({ posts, allPosts, loading }) {
  const { t } = useTranslation();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 頁面動畫載入效果
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`article-container ${isLoaded ? 'content-loaded' : 'content-hidden'}`}
    >
      <h1 className={`${isLoaded ? 'fade-in-element' : ''}`}>
        {t('about.title')}
      </h1>

      {loading ? (
        <p>Loading Medium posts…</p>
      ) : (
        <MediumPosts posts={posts} allPosts={allPosts} />
      )}
    </div>
  );
}
